import DialogConfirm from './DialogConfirm'

export { DialogConfirm }
export default DialogConfirm
